import React, { Component } from 'react'
import '../Home/Icons.css'
import '../Core/Main.css'

class IconPicker extends Component {
	constructor(props) {
		super(props)
		this.state = {
			icons: null,
			display: false
		}
	}

	handleClick = () => {
		let display = (this.state.display) ? false : true
		this.setState({ display: display })
	}

	handleSelect = (id) => {
		this.props.onChange(id)
		this.setState({ display: false })
	}

	render() {
		const nbRows = 8
		let row = null
		const display = (this.state.display) ? 'block' : 'none'
		let iconJSX = null
		if (this.props.icons)
		{
			let table_k = -1
			let table_icons = []
			for (let i = 0; i < this.props.icons.length; i++)
			{
				if (i % nbRows === 0)
				{
					if (row !== null)
						table_icons.push(row)
					row = []
				}
				row.push(this.props.icons[i])
			}
			if (row && row.length > 0)
				table_icons.push(row)
			iconJSX = (
				<table className="icons-table">
					<tbody>
						{table_icons && table_icons.map(( row ) => {
							table_k++
							return (
								<tr key={table_k}>
									{row && row.map(({ _id, name, lineal, fill }) => {
										let prev = null
										let classname = (this.props.theme === "blank") ? "blank" : null
										let icons = (this.props.type === "lineal") ? lineal : fill
										for (let i = 0; i < icons.length; i++)
										{
											if (icons[i].theme === this.props.theme)
											{
												prev = icons[i].icon
												break
											}
										}
										return (
											<td key={_id} className={classname} onClick={this.handleSelect.bind(this, _id)}>
												<img src={prev} alt={name} title={name} />
											</td>
										)
									})}
								</tr>
							)
						})}
					</tbody>
				</table>
			)
			/*iconJSX = (
				<table className="icons-table">
					<tbody>
						{table_icons && table_icons.map(( row ) => {
							table_k++
							return (
								<tr key={table_k}>
									{row && row.map(({ _id, name, icon, icons }) => {
										let prev = null
										let classname = null
										if (this.props.type === "color")
										{
											for (let i = 0; i < icons.length; i++)
											{
												if (icons[i].theme === this.props.theme._id)
												{
													prev = icons[i].icon
													break
												}
											}
										}
										else if (this.props.type === "blank")
										{
											classname = "blank"
											prev = icon
										}
										return (
											<td key={_id} className={classname} onClick={this.handleSelect.bind(this, _id)}>
												<img src={prev} alt={name} title={name} />
											</td>
										)
									})}
								</tr>
							)
						})}
					</tbody>
				</table>
			)*/
		}
		let noneJSX = null
		if (this.props.allowNone)
		{
			noneJSX = (
				<div
					onClick={this.handleSelect.bind(this, null)}
					className="text-sm font-semibold text-gray-700"
					style={{ cursor: 'pointer', padding: '8px 12px', borderBottom: '1px solid #e5e7eb' }}
				>
					Sans icône
				</div>
			)
		}
		return (
			<div>
				<button
					type="button"
					onClick={this.handleClick}
					className="text-sm font-semibold text-indigo-600 rounded-lg px-4 py-2"
					style={{ backgroundImage: 'none', backgroundColor: '#fff', border: '1px solid #C7D2FE', boxShadow: 'none' }}
				>{(this.state.display) ? "Fermer" : "Changer l'icône"}</button>
				<div className="icon-picker" style={{ display: display, border: '1px solid #E5E7EB', borderRadius: '12px', boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1)', maxHeight: '280px', overflowY: 'auto' }}>
					{noneJSX}
					{iconJSX}
				</div>
			</div>
		)
	}
}

export default IconPicker
